export default "__VITE_ASSET__DynDHj_d__"